<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <h2>Mot de passe oublié</h2>

      @if (emailSent) {
        <div class="alert alert-success" role="status">
          Un email de réinitialisation a été envoyé à l'adresse fournie. Consultez votre boîte de réception et vos courriers indésirables.
        </div>
      }
      @if (error) {
        <div class="alert alert-danger" role="alert">
          Impossible d'envoyer l'email de réinitialisation. Vérifiez votre adresse et réessayez.
        </div>
      }

      <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
        <div class="form-group mb-3">
          <label for="email">Adresse e-mail</label>
          <input type="email" id="email" class="form-control" formControlName="email" placeholder="Entrez votre e-mail" />
          @if (forgotForm.get('email')?.invalid && forgotForm.get('email')?.touched) {
            <div class="text-danger">
              L'adresse e-mail est requise et doit être valide.
            </div>
          }
        </div>

        <button type="submit" class="btn btn-primary" [disabled]="forgotForm.invalid || isSending">{{ isSending ? 'Envoi en cours…' : 'Valider' }}</button>
      </form>
    </div>
  </div>
</div>
